// extracted by mini-css-extract-plugin
module.exports = {"phoneInput":"styles_phoneInput__VoSKx","input":"styles_input__DylH3"};